import React, { useCallback, useContext, useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import LinkButton from '../../ui/LinkButton';
import Section from '../../ui/Section';
import { LocationFormInputs } from '../types';
import { renderDefaultLocationInputValues } from './helper';
import LocationInputs from './LocationInputs';
import PractitionerFormContext from './PractitionerFormContext';

const AddButton = styled(LinkButton).attrs({
  type: 'button',
})`
  margin-top: -20px;
  margin-bottom: 32px;
`;

function getSelectedLocationsArrayFromMap(selectedLocations: any) {
  if (selectedLocations) {
    const locations: LocationFormInputs[] = [];
    selectedLocations &&
      selectedLocations.forEach((value: LocationFormInputs, key: number) => {
        locations[key] = value;
      });
    return locations;
  }

  return [];
}

export const AddLocationFormSection = ({ onClose }: { onClose?: () => void }) => {
  const { control } = useFormContext();
  const { onSelectSearchedLocation, selectedLocations } = useContext(PractitionerFormContext);
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'locations',
  });

  const locations = getSelectedLocationsArrayFromMap(selectedLocations);

  const addNewLocation = useCallback(() => {
    append(renderDefaultLocationInputValues());
  }, [append]);

  useEffect(() => {
    addNewLocation();
  }, [addNewLocation]);

  const handleRemoveItem = (index: number) => {
    remove(index);
    onSelectSearchedLocation && onSelectSearchedLocation(null, index);
    if (index === 0) {
      onClose && onClose();
    }
  };

  return (
    <React.Fragment>
      {fields.map((field: any, index: number) => {
        const locationValues = locations && locations.length && locations[index];
        return (
          <React.Fragment key={field.id}>
            <Section
              title={index === 0 ? 'Add Location' : 'Add Another Location'}
              closeModalMessage="Are you sure you want to remove Location for this Health Practitioner?"
              onCloseClick={fields.length - 1 === index ? () => handleRemoveItem(index) : undefined}
            >
              <LocationInputs
                index={index}
                field={field}
                values={locationValues ? renderDefaultLocationInputValues(locationValues) : null}
              />
            </Section>
            {fields.length - 1 === index && (
              <AddButton onClick={addNewLocation} iconLeft="add" iconSize={20}>
                Add Another Location
              </AddButton>
            )}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

export default AddLocationFormSection;
